import { Component, Input, OnInit } from '@angular/core';
import { AlertService, IAlertType, ProjectsStoreService } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder } from '@clr/angular';
import { Projects } from '../../../_shared/interfaces';
import { DatePipe, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";
import moment from 'moment';

@Component({
  selector: 'app-project-card',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    RouterLink,
    DatePipe
  ],
  templateUrl: './project-card.component.html',
  styleUrl: './project-card.component.sass'
})
export class ProjectCardComponent implements OnInit {
  projects: Projects[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() companyId: number = 0;
  @Input() projectId: string = '';
  @Input() active: boolean = true;
  @Input() employeeID: number = 0;
  @Input() employeeLeader: number = 0;

  constructor(
    private prss: ProjectsStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit() {
    this.loading = true;
    this.loadList(this.companyId, this.projectId, this.employeeID, this.employeeLeader);
  }

  loadList(childMessage: number, projectID: string, employeeID: number, employeeLeader: number) {
    this.prss.filterProjectsPPS(childMessage, projectID, employeeLeader, 'all').subscribe({
        next: data => {
          if (!data || !data.object || data.object.length === 0) {
            this.alertDispatcher.alertConfig.message = 'Keine Projekte gefunden!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
            return;
          }
          this.projects = data.object;
          this.descSort = ClrDatagridSortOrder.DESC;
        },
        complete: () => {
          this.loading = false;
        },
        error: () => {
          return
        }
      });
  }

  formatProjectDate(value: string | null | undefined): string {
    if (!value) {
      return '-';
    }

    const parsed = moment(value, ['DD.MM.YYYY', 'YYYY-MM-DD'], true);
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : value;
  }
}
